module.exports = __webpack_public_path__ + "img/capture-front.d131392a.png";